// ** Initial State
const initialState = {
  dropdown: [],
  dropdownFormatted: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedEmployeeGroup: null
}

const employeeGroups = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EMPLOYEE_GROUPS_DROPDOWN':
      return { 
        ...state, 
        dropdown: action.data,
        dropdownFormatted: action.data.map(item => ({
          label: item.group_name,
          value: item.id,
        }))
      }
    case 'GET_ALL_EMPLOYEE_GROUPS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_EMPLOYEE_GROUPS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_EMPLOYEE_GROUP':
      return { ...state, selectedEmployeeGroup: action.selectedEmployeeGroup }
    case 'ADD_EMPLOYEE_GROUP':
      return { ...state }
    case 'DELETE_EMPLOYEE_GROUP':
      return { ...state }
    default:
      return { ...state }
  }
}
export default employeeGroups
